define('MM/Components/ContentSearch/FacetSingleChoicePanel',[
    "jquery",
    "knockout",
    "underscore",
    "score_bootstrap/Utils/UrlHelper",
    "MM/Models/ContentSearch/FacetDropdownViewModel",
    "MM/Models/ContentSearch/FacetSingleChoiceValue",
    "eventManager"
], function ($, ko, _, urlHelper, FacetDropdownViewModel, FacetSingleChoiceValue, eventManager) {
    "use strict";

    var searchLogic = ["and", "or_total_count", "or_incremental_count"];

    function FacetSingleChoicePanel(panelElement, allPreselected, urlParam) {
        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            return facetPanel;
        }

        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.data("title"),
            searchLogicType = $dataEl.data("search-logic-type").toLowerCase(),
            preselectedValueByBackend = $dataEl.data("preselected-value"),
            preselectedByTitle = allPreselected[title] || preselectedValueByBackend || "",
            initialSelectedOptionText = $dataEl.data("placeholder"),
            facets = [],
            facetsToDisableOnSelect = $dataEl.data("disable-facets-on-select"),
            facetsToTriggerDisable = $dataEl.data("facets-to-trigger-disable");

        if (preselectedValueByBackend && !window.location.hash) {
            urlHelper.setHashValue(window.location, urlParam, title + ":" + preselectedValueByBackend);
        }

        var viewModel = new FacetDropdownViewModel(initialSelectedOptionText);
        ko.applyBindings(viewModel, $(panelElement).get(0));

        var koCheckedValue = ko.observable(preselectedByTitle instanceof Array ? preselectedByTitle[0] : preselectedByTitle);

        $(".js-row", panelElement).each(function () {
            var $el = $(this),
                id = $el.data("id"),
                val = $el.data("value").toString(),
                text = $el.find('.score-facet-value').text();
            facets.push(new FacetSingleChoiceValue(id, val, text, $el[0], koCheckedValue));
        });

        $(".ipa-back", panelElement).on("click", function (e) {
            e.preventDefault();
            $(".score-button-menu", panelElement).removeClass("open");
        });

        Object.defineProperties(this, {
            title: { value: title },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets: { get: Array.prototype.slice.bind(facets) },
            asString: {
                get: function () {
                    //console.log('koCheckedValue: ', koCheckedValue());
                    var selectedArray = this.facets.filter((function (facet) { return facet.value === koCheckedValue(); }).bind(this));

                    if (selectedArray.length) {
                        //console.log('facet single choice are: ', selectedArray);
                        viewModel.selectedOptionText(selectedArray[0].text);
                        viewModel.isAnySelected(true);
                        return this.title + ':' + selectedArray[0].value;
                    } else {
                        //console.log('facet single choice is null');
                        viewModel.isAnySelected(false);
                        return null;
                    }
                }
            }
        });

        this.selectValues = function(selectedValues) {
            var selectedByTitle = selectedValues[title] || "";
            facets.forEach(function (facet) {
                var oldValue = facet.selected();
                var newValue = selectedByTitle.indexOf(facet.value) > -1;
                if (oldValue !== newValue) {
                    facet.selected(selectedByTitle.indexOf(facet.value) > -1);
                }
            });
        };

        this.selectedValues = ko.pureComputed((function () {
            return this.facets.filter((function (facet) {
                // I cannot use facet.selected() here because it causes two subscribe() call to two different ko.observables. 
                // In result it causes 2 requests - these 2 requests are unnecessary so I have to check the main source of value.
                return facet.value === koCheckedValue();
            }).bind(this));
        }).bind(this));

        this.unselectAll = function unselectAll() {
            this.selectedValues().forEach(function (value) {
                value.checked('');
            });

            viewModel.selectedOptionText(initialSelectedOptionText);
        };

        this.selectValue = function selectValue(value) {
            // the 'find' was replaced by 'filter...[0]' to have compatibility with IE
            var selected = this.facets.filter(function (obj) { return obj.value === value; })[0];
            selected.checked(value);
        };

        $(panelElement).data('facet', this);

        eventManager.subscribe("SearchResponseEvent:facet selected", facetSelectedResponse.bind(this));
        eventManager.subscribe("SearchResponseEvent: trigger facet checked", handleTriggerFacetChanged.bind(this));
        eventManager.subscribe("SearchResponseEvent: trigger facet unchecked", handleTriggerFacetChanged.bind(this));

        function facetSelectedResponse() {
            var triggerFacetChecked,
                triggerFacetUnchecked,
                facetsToTriggerDisableList = facetsToTriggerDisable ? facetsToTriggerDisable.split(',') : undefined;

            if (!facetsToDisableOnSelect || !facetsToDisableOnSelect.length) {
                return;
            }

            facets.filter((function (facet) {
                if (facet.selected() && facetsToTriggerDisableList.includes(facet.id.guid)) {
                    triggerFacetChecked = true;
                } else if (!facet.selected() && facetsToTriggerDisableList.includes(facet.id.guid)) {
                    triggerFacetUnchecked = true;
                }
            }));

            if (triggerFacetChecked) {
                eventManager.trigger("SearchResponseEvent: trigger facet checked", facetsToDisableOnSelect, true);
            }
            else if (triggerFacetUnchecked) {
                eventManager.trigger("SearchResponseEvent: trigger facet unchecked", facetsToDisableOnSelect, false);
            }
        }

        function handleTriggerFacetChanged(facetsForDisable, action) {

            if (!facets.length || !facetsForDisable.length) {
                return;
            }

            var targetedFacets = facetsForDisable.split(','),
                anyAltered = false,
                anyChecked = false;

            facets.filter((function (facet) {
                if (facet.checked()) {
                    anyChecked = true;
                }

                if (targetedFacets.includes(facet.id.guid)) {
                    facet.disabled(action);
                    anyAltered = true;

                    if (targetedFacets.length === 1 && !anyChecked && action) {
                        facets[0].checked(facets[0].value);
                    }
                }
            }));

            if (targetedFacets.length === facets.length && anyAltered) {
                viewModel.isDisabledDropdownButton(action);
            }
        };
    }

    return FacetSingleChoicePanel;
});
